import './style.css';
import { CONFIG } from './config';
import { Game } from './engine/Game';

/** Application entry point: find the canvas, build the game, expose the test API. */
function bootstrap(): void {
  const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
  if (!canvas) {
    throw new Error('[main] #game-canvas element missing from index.html');
  }

  canvas.width = CONFIG.canvas.width;
  canvas.height = CONFIG.canvas.height;

  const game = new Game(canvas);
  game.boot();

  // Deterministic test contract consumed by Playwright — see docs/ARCHITECTURE.md.
  window.__GAME__ = game.testApi;
}

// `type="module"` scripts are deferred, but guard for both timing cases.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
